import { useContext, useMemo } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import { CreationProducerInfo } from "../../../../../generated/data-contracts";
import { AvisSection } from "../../../../shared/components/form";
import {
  AvisSimpleTable,
  IColumnConfig,
} from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationAdditionalInfoProps {
  data: CreationProducerInfo[] | undefined;
}

export function CreationAdditionalInfo(
  props: Readonly<ICreationAdditionalInfoProps>,
) {
  const { res } = useContext(AvisContext);
  const { data } = props;

  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      {
        metadata: AvisConstants.table_default_column_metadata,
        type: "String",
        name: "name",
        translation: res("authors_Creation_Section_Additional_label_Producer"),
      },
    ];
  }, [res]);
  if (!data) return; //Do not draw section if is not defined

  return (
    <AvisSection
      collapsable
      title={res("authors_Creation_Section_Additional_Title")}
      textToDisplayKey="portal_RH_CreationCard_AV_1"
    >
      <AvisSimpleTable<CreationProducerInfo>
        columnMetadata={columnMetadata}
        data={data}
      />
    </AvisSection>
  );
}
